import React from "react";
import { Link } from "react-router-dom";
import FilterGenres from "../FilterByGenres/FilterByGenres";
import FilterCreats from "../FilterGameCreated/FilterGameCreated";
import OrderName from "../OrderByName/OrderByName";
import OrderRating from "../OrderByRating/OrderByRating";
import SearchBar from "../SearchBar/SearchBar";
import "./NavBar.css";
import logo from "../assets/logo.svg";

export default function NavBar({setcurrentPage, setOrden, allGenres, orden, handleClick}){

    return(
        <div className="containerNavbar">
            <img className="imgLogo" src={logo} alt="not found"/>
            <div className="refresh">
            <button className="buttonRefresh"  onClick={event=> {handleClick(event)}}>Actualizar</button>  
            </div>
            <div className="searchbar">
            <SearchBar className="search" setcurrentPage={setcurrentPage}/>
            </div>
            <div className="containerLinkCreatedGame">
            <Link className="LinkCreatedGame" to="/videogame">Crea tu videojuego</Link>
            </div>
            <OrderName 
            setcurrentPage={setcurrentPage}
            setOrden={setOrden}
            orden={orden}
            />
            <OrderRating
            setcurrentPage={setcurrentPage}
            setOrden={setOrden}
            />
            <FilterCreats
            setcurrentPage={setcurrentPage}
            />

            <FilterGenres
            setcurrentPage={setcurrentPage}
            allGenres={allGenres}
            />

            </div>
    )
}